import { render, staticRenderFns } from "./NataleCapodanno.vue?vue&type=template&id=9d6f00aa"
import script from "./NataleCapodanno.vue?vue&type=script&lang=js"
export * from "./NataleCapodanno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports